import { DataGridTemplate } from "../../../../shared/data-grid/data-grid.template";
import { FormGroup, FormBuilder, AbstractControl, ValidationErrors } from "@angular/forms";
import { FilterableService } from "../../../mesc/filterable-service";
import { RequestService } from "../request.service";
import { Injector } from "@angular/core";

export class ComponentDetail extends DataGridTemplate {
    editForm: FormGroup;
    components: FilterableService = new FilterableService();
    itemService: FilterableService = new FilterableService();
    selectedComponentCategory: string;
    private readonly formBuilder: FormBuilder;
    private readonly requestService: RequestService;

    constructor(
        private readonly injector: Injector
    ) {
        super();
        this.pageable = false;
        this.controls.delete = false;
        this.controls.excel = false;
        this.controls.add = false;
        this.isNotificationsEnabled = false;
        this.gridState.take = 999;
        this.saveUserSettings = false;
        this.formBuilder = this.injector.get(FormBuilder);
        this.requestService = this.injector.get(RequestService);

        this.editForm = this.formBuilder.group({
            Id: [],
            RequestItems: [],
            ItemIds: [[], [this.itemValidator]]
        });
    }


    /**
     * Custom Validator for item save
     * Enable saving if at least 1 item is selected or
     * The tooling form is already valid.
     * e.g(at least 1 item in another component is selected)
     */
    itemValidator = (control: AbstractControl): ValidationErrors => {
        let response = { valid: false };
        if (control.value && control.value.length || this.requestService.isToolingFormValid.value) response = null;
        return response;
    }


    setComponents(data: any[]) {
        this.components.next(data);
    }


    read(opts: any): Promise<any> {
        this.selectedComponentCategory = opts.parentEditDataItem.componentCategoryView.Id;
        const _data = opts.parentEditDataItem.RequestComponents.map(x => {
            x.Name = x.componentViewDto.Name;
            x.Id = x.componentViewDto.Id;
            x.ItemIds = x.RequestItems
                .filter(i => i.IsSelected)
                .map(i => i.Item.Id);
            x.ItemNames = x.RequestItems
                .filter(i => i.IsSelected)
                .map(i => i.Item.Name)
                .join(', ');
            return x;
        });
        return Promise.resolve(_data);
    }


    edit(dataItem: any): void {
        const _items = dataItem.RequestItems.map(x => {
            x.Name = x.Item.Name;
            x.Id = x.Item.Id;
            return x;
        })
        this.itemService.next(_items);
    }


    save(dataItem: any, isNew: boolean): Promise<any> {
        dataItem.RequestItems.forEach(i => {
            if (dataItem.ItemIds) i.IsSelected = dataItem.ItemIds.some(x => x === i.Id);
            return i;
        })
        return Promise.resolve();
    }


    create(parentEditDataItem: any): void { }

    delete(dataItem: any): Promise<any> { return null; }

    isDisabled = (id: string, dataItem: any): boolean => {
        switch (id) {
            case 'save':
                return !this.editForm.valid;
            default:
                return false;
        }
    }



    columns: any[] = [
        {
            field: 'componentViewDto.Name',
            title: 'Item Name',
            detail: {
                field: 'componentViewDto',
                textField: 'Name'
            }
        },
        {
            field: 'ItemNames',
            title: 'Item Descriptions',
            template: {
                type: 'multiselect',
                name: 'ItemIds',
                textField: 'Name',
                valueField: 'Id',
                required: true,
                service: this.itemService
            }
        }
    ];

}
